import styled, { keyframes } from 'styled-components';
import { color, height, HeightProps } from 'styled-system';

const animationRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(5deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(0deg);
  }
`;

export const RotateLoader = styled.div<HeightProps & { color?: string; withAnimation?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${color};
  ${height};

  > svg {
    margin-bottom: 20px;
    animation-name: ${props => props.withAnimation && animationRotate};
    animation-duration: 1.7s;
    animation-fill-mode: both;
    animation-timing-function: linear;
    transform-origin: bottom center;
    animation-play-state: running;
    animation-iteration-count: infinite;
  }
`;

RotateLoader.defaultProps = {
  withAnimation: true,
  color: 'coolGrey'
};
